import React from 'react'
import PropTypes from 'prop-types'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import ChatBubble from 'components/material-symbol/icons/ChatBubble'
import StreamSendMessageButton from 'components/stream-messaging/send-message-button'
import SensitiveInfoWrapper from 'lib/auth/SensitiveInfoWrapper'
import useStyles from './styles'

const MessageIconButton = ({ studentName, ...props }) => {
  const classes = useStyles()
  const label = `Message ${studentName}`
  return (
    <Tooltip title={label}>
      <IconButton
        {...props}
        aria-label={label}
        className={`${classes.borderedActionButton} ${classes.messageButton}`}
      >
        <ChatBubble fontSize="small" fill={0} />
      </IconButton>
    </Tooltip>
  )
}

MessageIconButton.propTypes = {
  studentName: PropTypes.string.isRequired,
}

// Opens the coach's chat thread with the contact the campaign was sent to (the
// guardian for minors), by their Stream user id. Without one there is nobody to
// message, so nothing is shown.
export default function MessageStudentButton({ recipient }) {
  const { student, contact } = recipient
  const name =
    [student?.firstName, student?.lastName].filter(Boolean).join(' ') ||
    'student'
  const externalId = contact?.externalId
  if (!student?.id || !externalId) return null

  return (
    <SensitiveInfoWrapper>
      <StreamSendMessageButton
        userIds={[externalId]}
        component={MessageIconButton}
        studentName={name}
        data-testid={`campaign-message-${student.id}`}
      />
    </SensitiveInfoWrapper>
  )
}

MessageStudentButton.propTypes = {
  recipient: PropTypes.shape({
    contact: PropTypes.shape({ externalId: PropTypes.string }),
    student: PropTypes.shape({
      id: PropTypes.string,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
    }),
  }).isRequired,
}
